import AsyncFlow from '../asyncFlow';

//utils
import { isValid, startOfToday, isBefore, isAfter, addYears } from 'date-fns';
import subDays from 'date-fns/subDays';
import isEqual from 'lodash/isEqual';

import { validateEmail } from './../../utils/global';

const ERROR_TEXT = {
    tipologia: '',
    pk: '',
    sn: '',
    codice_utente: '',
    multiazienda: '',
    codice_azienda: '',
    cliente: '',
    email: '',
    data_scadenza: '',
};

const CREATE_LICENSE_DATA = {
    tipologia: 'Enterprise',
    pk: '',
    sn: '000000',
    codice_utente: '',
    multiazienda: false,
    codice_azienda: '',
    cliente: '',
    email: '',
    data_scadenza: null,
    hasScadenza: false,
};



export default AsyncFlow({
    store: 'create-license-data',
    initialState: {
        default_license_data: CREATE_LICENSE_DATA,
        new_license: CREATE_LICENSE_DATA,
        isChanged: false,
        isValid: true,
        errorText: ERROR_TEXT,

        codici_utente: [],
        is_sn_valid: true,
        statusAction: 'READY',
    },
    actions: ['RESET_CREATE_LICENSE_STORE', 'INITIALIZE_NEW_LICENSE_DATA', 'INITIALIZE_FIELD',
        'HANDLE_CHANGE_FIELD', 'VALIDATE_FIELD', 'VALIDATE_SN'],
}).extend({
    reducer: (state, action, { types }) => {

        var new_license_temp;
        var errorText_temp = state.errorText;
        var isValid_temp = false;

        switch (action.type) {
            case types.RESET_CREATE_LICENSE_STORE:
                return {
                    ...state,
                    default_license_data: CREATE_LICENSE_DATA,
                    new_license: CREATE_LICENSE_DATA,
                    isChanged: false,
                    isValid: true,
                    errorText: ERROR_TEXT,
                    codici_utente: [],
                    is_sn_valid: true,
                    status: 'READY',
                };

            case types.INITIALIZE_NEW_LICENSE_DATA_SUCCESS:
                new_license_temp = {
                    ...state.new_license,
                    pk: action.payload.product_key,
                    sn: (new Date().getFullYear().toString().substr(-2)).concat(action.payload.sn_quattro_cifre)
                };

                return {
                    ...state,
                    new_license: new_license_temp,
                    default_license_data: new_license_temp,
                    codici_utente: action.payload.codici_utente
                };


            case types.INITIALIZE_FIELD:
                var init_license = state.default_license_data;
                var reset_field_error = state.errorText;

                init_license[action.payload.field] = action.payload.value;
                reset_field_error[action.payload.field] = '';

                return {
                    ...state,
                    default_license_data: init_license,
                    new_license: init_license,
                    errorText: reset_field_error,
                };


            case types.HANDLE_CHANGE_FIELD:
                if (action.payload.field === 'hasScadenza') {
                    if (action.payload.newValue === false) {
                        new_license_temp = {
                            ...state.new_license,
                            [action.payload.field]: action.payload.newValue,
                            data_scadenza: null
                        };
                        errorText_temp.data_scadenza = '';
                    }
                    else
                        new_license_temp = {
                            ...state.new_license,
                            [action.payload.field]: action.payload.newValue,
                            data_scadenza: addYears(new Date(), 1)
                        };
                }
                else
                    new_license_temp = {
                        ...state.new_license,
                        [action.payload.field]: action.payload.newValue,
                    };

                var isChanged_temp = state.isChanged;

                if (isEqual(state.default_license_data, new_license_temp)) isChanged_temp = false;
                else isChanged_temp = true;

                return {
                    ...state,
                    new_license: new_license_temp,
                    isChanged: isChanged_temp,
                    errorText: errorText_temp
                };



            case types.VALIDATE_FIELD:

                switch (action.payload.field) {

                    case 'all':
                    case 'email':
                        if (state.new_license.email === '')
                            errorText_temp.email = 'Email non può essere vuota.';
                        else if (validateEmail(state.new_license.email)) errorText_temp.email = '';
                        else errorText_temp.email = 'Formato Email non valido.';

                    case 'all':
                    case 'data_scadenza':
                        const data_scadenza = state.new_license.data_scadenza;

                        if (state.new_license.hasScadenza === true) {

                            if (data_scadenza !== null) {

                                if (isValid(data_scadenza)) {
                                    if (isBefore(data_scadenza, subDays(startOfToday(), 1))
                                        || isAfter(data_scadenza, new Date(2100, 1, 1)))
                                        errorText_temp.data_scadenza = 'Data Scadenza fuori range.';
                                    else errorText_temp.data_scadenza = '';

                                } else errorText_temp.data_scadenza = 'Data Scadenza non valida.';
                            }
                            else errorText_temp.data_scadenza = 'Data Scadenza non può essere vuota se la licenza non ha scadenza.';

                        }

                    case 'all':
                    case 'multiazienda':
                    case 'codice_azienda':
                        if (state.new_license.multiazienda === false)
                            if (state.new_license.codice_azienda === '')
                                errorText_temp.codice_azienda = 'Codice Azienda non può essere vuoto nelle licenze MultiAzienda.';
                            else
                                errorText_temp.codice_azienda = '';
                        else errorText_temp.codice_azienda = '';

                    case 'all':
                    case 'pk':
                        if (state.new_license.pk === '')
                            errorText_temp.pk = 'Product Key non può essere vuoto.';
                        else
                            errorText_temp.pk = '';

                    case 'all':
                    case 'codice_utente':
                        if (state.new_license.codice_utente === '')
                            errorText_temp.codice_utente = 'Codice Utente non può essere vuoto.';
                        else
                            errorText_temp.codice_utente = '';


                    default: break;
                }



                // controllo se ci sono errori di validazione
                if (errorText_temp.tipologia === ''
                    && errorText_temp.pk === ''
                    && errorText_temp.sn === ''
                    && errorText_temp.codice_utente === ''
                    && errorText_temp.multiazienda === ''
                    && errorText_temp.codice_azienda === ''
                    && errorText_temp.cliente === ''
                    && errorText_temp.email === ''
                    && errorText_temp.data_scadenza === '') isValid_temp = true;
                else isValid_temp = false;

                return {
                    ...state,
                    errorText: errorText_temp,
                    isValid: isValid_temp
                };

            case types.VALIDATE_SN:
                const sn = state.new_license.sn;


                if (action.payload.is_sn_valid === false) {
                    if (sn.length === 6) {
                        if (sn.charAt(0) === '0') {
                            errorText_temp.sn = 'Serial Number non può avere 0 come prima cifra.';
                        }
                        else errorText_temp.sn = 'Serial Number già utilizzato.';
                    }
                    else if (sn.length < 6)
                        errorText_temp.sn = 'Serial Number deve essere di 6 cifre.';
                }
                else errorText_temp.sn = '';


                // controllo se ci sono errori di validazione
                if (errorText_temp.tipologia === ''
                    && errorText_temp.pk === ''
                    && errorText_temp.sn === ''
                    && errorText_temp.codice_utente === ''
                    && errorText_temp.multiazienda === ''
                    && errorText_temp.codice_azienda === ''
                    && errorText_temp.cliente === ''
                    && errorText_temp.email === ''
                    && errorText_temp.data_scadenza === '') isValid_temp = true;
                else isValid_temp = false;

                return {
                    ...state,
                    errorText: errorText_temp,
                    isValid: isValid_temp
                };

            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        //initializeNewLicenseData
        initializeNewLicenseDataRequest: (anno) => ({
            type: types.INITIALIZE_NEW_LICENSE_DATA_REQUEST,
            payload: { anno },
        }),
        initializeNewLicenseDataSuccess: ({ codici_utente, product_key, sn_quattro_cifre }) => ({
            type: types.INITIALIZE_NEW_LICENSE_DATA_SUCCESS,
            payload: { codici_utente, product_key, sn_quattro_cifre },
        }),
        initializeNewLicenseDataFailed: error => ({ type: types.INITIALIZE_NEW_LICENSE_DATA_FAILED, error: true, payload: { error } }),


        initializeField: (field, value) => ({
            type: types.INITIALIZE_FIELD,
            payload: { field, value },
        }),
        handleChangeField: (field, newValue) => ({
            type: types.HANDLE_CHANGE_FIELD,
            payload: { field, newValue },
        }),
        validateField: (field) => ({
            type: types.VALIDATE_FIELD,
            payload: { field },
        }),

        resetCreateLicense: () => ({
            type: types.RESET_CREATE_LICENSE_STORE,
        }),

        validateSN: (is_sn_valid) => ({
            type: types.VALIDATE_SN,
            payload: { is_sn_valid },
        }),
    }),
});
